import {
    AfterViewInit,
    Component,
    ContentChildren,
    Directive,
    ElementRef,
    Input, OnChanges,
    OnInit,
    QueryList,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { CarouselItemDirective } from './carousel-item.directive';
import { animate, AnimationBuilder, AnimationFactory, AnimationPlayer, style } from '@angular/animations';

@Directive({
  selector: '.carousel-item'
})
export class CarouselItemElement {
}

@Component({
  selector: 'carousel',
  exportAs: 'carousel',
  template: `
      <div class="carousel-container">
            <section class="carousel-wrapper" #carouselWrapper [ngStyle]="carouselWrapperStyle">
              <ul class="carousel-inner" #carousel>
                <li *ngFor="let item of items;" class="carousel-item" [ngStyle]="itemStyle">
                  <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
                </li>
              </ul>
                <div (click)="next()" class="arrow next" *ngIf="items.length > 1"></div>
                <div (click)="prev()" class="arrow prev" *ngIf="items.length > 1"></div>
            </section>
      </div>
      <div class="thumbs-container" *ngIf="items.length > 1">
          <ul class="thumbs">
              <li *ngFor="let thumb of thumbs; let i = index"
                  [class.current]="currentSlide == i"
                  (click)="currentSlide = i"
              (click)="goToSlide(i)">
                  <div class="file" [class.video]="thumb.type=='video'" [ngStyle]="{backgroundImage: 'url(' + (thumb.thumb?thumb.thumb:thumb.url) + ')'}"></div>
              </li>
          </ul>
      </div>
  `,
  styles: [`
      :host {
          flex:1;
          display: flex;
          flex-direction: column;
      }
.carousel-container ul {
list-style: none;
margin: 0;
padding: 0;
width: 100000px;
}
.carousel-container {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.carousel-wrapper {
overflow: hidden;
width: 100%;
height: 300px;
    position: relative;
    flex:1;
}

.carousel-inner {
display: flex;
height: 100%;
}


.thumbs {
text-align: center;
margin-bottom: 0;
}
.thumbs li {
display: inline-block;
margin-right: 20px;
cursor:pointer;
    position:relative;
}

.thumbs li:after {
    content:'';
    position: absolute;
    left:0;
    top:0;
    width:calc(100% - 10px);
    height:calc(100% - 10px);
    border: 0px solid #fab500;
}
.thumbs li.current:after {
  border: 5px solid #fab500;
}

.thumbs .file {
height: 110px;
width: 110px;
background-size: cover;
}

.thumbs .file.video:after {
   content: '';
   position: absolute;
   top: 0;
   left: 0;
   height: 100%;
   width: 100%;
   background-image: url(/assets/images/play-button.svg);
   background-position: center;
   background-size: 40%;
   background-repeat: no-repeat;
   opacity: 0.8;
   z-index: 1;
}

.arrow {
    position: absolute;
    width: 40px;
    height: 100px;
    top: 50%;
    transform: translateY(-50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
}

.next {
    background-image: url(/assets/images/chevron-right.svg);
    right:20px;
}

.prev {
    background-image: url(/assets/images/chevron-left.svg);
    left:20px;
}

  `]
})
export class CarouselComponent implements AfterViewInit, OnChanges {
  @ContentChildren(CarouselItemDirective) items : QueryList<CarouselItemDirective>;
  @ViewChildren(CarouselItemElement, { read: ElementRef }) private itemsElements : QueryList<ElementRef>;
  @ViewChild('carousel', {static: false}) private carousel: ElementRef;
  @ViewChild('carouselWrapper', {static: false}) private carouselWrapper: ElementRef;
  @Input() thumbs = [];
  @Input() timing = '250ms ease-in';
  @Input() showControls = true;
  @Input() refresh: boolean;
  private player : AnimationPlayer;
  private itemWidth : number;
  private currentSlide = 0;
  carouselWrapperStyle = {};
  itemStyle = {};

  next() {
    if (this.currentSlide + 1 === this.items.length) {
        this.currentSlide = -1;
    }

    this.currentSlide = (this.currentSlide + 1) % this.items.length;
    const offset = this.currentSlide * this.itemWidth;
    const myAnimation : AnimationFactory = this.buildAnimation(offset);
    this.player = myAnimation.create(this.carousel.nativeElement);
    this.player.play();
  }

  private buildAnimation( offset ) {
    return this.builder.build([
      animate(this.timing, style({ transform: `translateX(-${offset}px)` }))
    ]);
  }

  prev() {
    if (this.currentSlide === 0) {
        this.currentSlide = this.items.length;
    }

    this.currentSlide = ((this.currentSlide - 1) + this.items.length) % this.items.length;
    const offset = this.currentSlide * this.itemWidth;

    const myAnimation : AnimationFactory = this.buildAnimation(offset);
    this.player = myAnimation.create(this.carousel.nativeElement);
    this.player.play();
  }

  goToSlide(slide) {
      this.currentSlide = slide;
      const offset = this.currentSlide * this.itemWidth;

      const myAnimation: AnimationFactory = this.buildAnimation(offset);
      this.player = myAnimation.create(this.carousel.nativeElement);
      this.player.play();
  }

  constructor( private builder : AnimationBuilder ) {
  }

  ngOnChanges(changes: SimpleChanges) {
      // For some reason only here I need to add setTimeout, in my local env it's working without this.
      setTimeout(() => {
          this.goToSlide(0)
          this.itemWidth = this.carouselWrapper.nativeElement.offsetWidth;
          this.itemStyle = {
              width: `${this.itemWidth}px`
          };
      });
  }

  ngAfterViewInit() {
    // For some reason only here I need to add setTimeout, in my local env it's working without this.
    setTimeout(() => {
      //this.itemWidth = this.itemsElements.first.nativeElement.offsetWidth;
        this.itemWidth = this.carouselWrapper.nativeElement.offsetWidth;
        this.itemStyle = {
            width: `${this.itemWidth}px`
        };
    });

  }

}
